import { HttpError } from '@littlebird/auth-client';

import { backendApis } from '@/backendApis';
import { electronApis } from '@/features/electron-api';

export type RecordingSession = {
  meetingId: string;
  deviceId: string;
  sessionId: string;
  transcriptRevision?: string | null;
};

export function keepRecordingSessionAlive(
  session: RecordingSession,
  onFailure: () => void
) {
  let stopped = false;
  let renewing = false;
  const releaseBackgroundTimers =
    electronApis.window.keepTimersRunningInBackground();
  const timer = setInterval(async () => {
    if (stopped || renewing) return;
    renewing = true;
    try {
      await backendApis.meetingNotes.renewRecording(session);
    } catch (error) {
      if (!stopped && error instanceof HttpError && error.status === 409) {
        stopped = true;
        clearInterval(timer);
        releaseBackgroundTimers();
        onFailure();
      }
    } finally {
      renewing = false;
    }
  }, 60_000);
  return () => {
    stopped = true;
    clearInterval(timer);
    releaseBackgroundTimers();
  };
}
